import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import folderUpdaters from '@/api/updaters/content-studio/folder';
import {CONTENT_LAB, FOLDERS} from '../../consts';

function useCreateFolder() {
  return useMutation({
    mutationFn: ({name}: {name: string}) => {
      return folderUpdaters.createFolder(name);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [CONTENT_LAB, FOLDERS]});
    },
  });
}

export default useCreateFolder;
